module.exports = __webpack_public_path__ + "img/estado.a1ffbfc1.svg";